'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';

/**
 * EcoImg 通过 CSS 变量使用 `url('…')`；上传图路径若含单引号、未编码空格等会导致背景失效。
 * 在此规范化后再传入，避免改动 EcoImg 本身。
 */
function toEcoImgBackgroundSrc(src: string | undefined): string | undefined {
    if (src == null || src === '') return src;
    return src.trim().replace(/\\/g, '%5C').replace(/'/g, '%27');
}

export default function Content({ id, data = {} }: ContentServerProps) {
    const { locale = 'us' } = getLocal();
    const { title, sub_title, more_btn_text, more_btn_href, list = [], backgroundColor = '#ffffff' } = data;
    const has_right_btn = !!more_btn_text && !!more_btn_href;

    const handleGtmBtn = (val: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'banner_switch',
            position: `Homepage_Swiper_4_${val}`,
            button_name: val,

            __btn_id1: `editor-${id} .stxwkp-swiper-${val}`,
            __btn_id2: `stxwkp-swiper-${val}`,
            __btn_type: 'common',
        });
    };

    return (
        <GloLayout
            className={`editor-index-list-c1`}
            id={id}
            data={data}
            floorName="index-list-c1"
            style={{ backgroundColor: locale === 'jp' ? backgroundColor : undefined }}
        >
            <div className="index-list-c1-title eco-content-v2">
                <div>
                    <h2 className="index-list-c1-title-l">{title}</h2>
                    <div className="index-list-c1-subtitle-l">{sub_title}</div>
                </div>
                {has_right_btn && (
                    <EcoLink
                        href={more_btn_href}
                        className="index-list-c1-more-btn index-list-c1-title-r GtmModuleData-btn-href"
                        dataLayer={{
                            ...getUrlGtm(more_btn_href, locale, {
                                list_name: title,
                                button_name: more_btn_text,
                                product_name: title,
                            }),

                            __btn_id1: `editor-${id} .index-list-c1-title-r`,
                            __btn_id2: more_btn_href,
                            __btn_type: 'href',
                        }}
                    >
                        {more_btn_text}
                        <span className="index-list-c1-arrow"></span>
                    </EcoLink>
                )}
            </div>
            <Swiper
                className="index-list-c1-list-swiper"
                modules={[Navigation]}
                navigation={{ prevEl: `#editor-${id} .stxwkp-swiper-Left`, nextEl: `#editor-${id} .stxwkp-swiper-Right` }}
                spaceBetween={12}
                slidesPerView="auto"
            >
                {list.map((item: any, idx: number) => (
                    <SwiperSlide className="index-list-c1-list-swiper-slide" key={idx}>
                        <EcoLink
                            className={`index-list-c1-list-item GtmModuleData-btn-href stxwkp-item-${idx}`}
                            href={item.href}
                            dataLayer={{
                                ...getUrlGtm(item.href, locale, {
                                    list_name: item.title,
                                    button_name: 'CardItem',
                                    product_name: item.title,
                                }),

                                __btn_id1: `editor-${id} .stxwkp-item-${idx}`,
                                __btn_id2: item.href,
                                __btn_type: 'href',
                            }}
                        >
                            <EcoImg
                                pc={toEcoImgBackgroundSrc(item.pc)}
                                pad={toEcoImgBackgroundSrc(item.pc)}
                                h5={toEcoImgBackgroundSrc(item.h5)}
                                className="index-list-c1-item-img"
                            />
                            <div className="index-list-c1-item-msg">
                                <div className="index-list-c1-item-title">{item.title}</div>
                                {!!item.desc && (
                                    <div className="index-list-c1-item-desc">
                                        <span className="index-list-c1-item-desc-text">{item.desc}</span>
                                        <span className="index-list-c1-item-arrow"></span>
                                    </div>
                                )}
                            </div>
                        </EcoLink>
                    </SwiperSlide>
                ))}
                <div className={`index-list-c1-control`}>
                    <div
                        className={`swiper-button-prev GtmModuleData-btn-common stxwkp-swiper-Left`}
                        data-btn-id="stxwkp-swiper-Left"
                        onClick={() => handleGtmBtn('Left')}
                    ></div>
                    <div
                        className={`swiper-button-next GtmModuleData-btn-common stxwkp-swiper-Right`}
                        data-btn-id="stxwkp-swiper-Right"
                        onClick={() => handleGtmBtn('Right')}
                    ></div>
                </div>
            </Swiper>

            {has_right_btn && (
                <EcoLink href={more_btn_href} className="index-list-c1-more-btn index-list-c1-f-btn">
                    {more_btn_text}
                    <span className="index-list-c1-arrow"></span>
                </EcoLink>
            )}
        </GloLayout>
    );
}
